/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, max: NonNullable<unknown> }} Draftsusage1Inputs */

const en_draftsusage1 = /** @type {(inputs: Draftsusage1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Drafts: ${i?.used}/${i?.max}`)
};

const de_draftsusage1 = /** @type {(inputs: Draftsusage1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entwürfe: ${i?.used}/${i?.max}`)
};

/**
* | output |
* | --- |
* | "Drafts: {used}/{max}" |
*
* @param {Draftsusage1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const draftsusage1 = /** @type {((inputs: Draftsusage1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draftsusage1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draftsusage1(inputs)
	return de_draftsusage1(inputs)
});
export { draftsusage1 as "draftsUsage" }